var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedBubbleNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 369 164"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.372 .26)",
    fill: "#FF386B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 22)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-1 0 0 1 59.697 0)",
    cx: 29.848,
    cy: 111.428,
    rx: 29.848,
    ry: 29.428
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-1 0 0 1 548.657 0)",
    cx: 274.329,
    cy: 54,
    rx: 23.329,
    ry: 23
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-1 0 0 1 355.7 0)",
    cx: 177.85,
    cy: 89.5,
    rx: 24.85,
    ry: 24.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-1 0 0 1 220.971 0)",
    cx: 110.486,
    cy: 34,
    rx: 34.486,
    ry: 34
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-1 0 0 1 50.714 0)",
    cx: 25.357,
    cy: 25,
    rx: 25.357,
    ry: 25
  }))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzY5cHgiIGhlaWdodD0iMTY0cHgiIHZpZXdCb3g9IjAgMCAzNjkgMTY0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPkdyb3VwPC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4zNzE3MDAsIDAuMjU5NjAwKSIgZmlsbD0iI0ZGMzg2QiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9InJlZC1idWJibGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcwLjAwMDAwMCwgMjIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZWxsaXBzZSBpZD0iT3ZhbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjkuODQ4NDAwLCAxMTEuNDI4MDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0yOS44NDg0MDAsIC0xMTEuNDI4MDAwKSAiIGN4PSIyOS44NDg0IiBjeT0iMTExLjQyOCIgcng9IjI5Ljg0ODQiIHJ5PSIyOS40MjgiPjwvZWxsaXBzZT4KICAgICAgICAgICAgICAgIDxlbGxpcHNlIGlkPSJPdmFsIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNzQuMzI4NTcxLCA1NC4wMDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTI3NC4zMjg1NzEsIC01NC4wMDAwMDApICIgY3g9IjI3NC4zMjg1NzEiIGN5PSI1NCIgcng9IjIzLjMyODU3MTQiIHJ5PSIyMyI+PC9lbGxpcHNlPgogICAgICAgICAgICAgICAgPGVsbGlwc2UgaWQ9Ik92YWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3Ny44NTAwMDAsIDg5LjUwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMTc3Ljg1MDAwMCwgLTg5LjUwMDAwMCkgIiBjeD0iMTc3Ljg1IiBjeT0iODkuNSIgcng9IjI0Ljg1IiByeT0iMjQuNSI+PC9lbGxpcHNlPgogICAgICAgICAgICAgICAgPGVsbGlwc2UgaWQ9Ik92YWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMC40ODU3MTQsIDM0LjAwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMTEwLjQ4NTcxNCwgLTM0LjAwMDAwMCkgIiBjeD0iMTEwLjQ4NTcxNCIgY3k9IjM0IiByeD0iMzQuNDg1NzE0MyIgcnk9IjM0Ij48L2VsbGlwc2U+CiAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPGVsbGlwc2UgaWQ9Ik92YWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1LjM1NzE0MywgMjUuMDAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0yNS4zNTcxNDMsIC0yNS4wMDAwMDApICIgY3g9IjI1LjM1NzE0MjkiIGN5PSIyNSIgcng9IjI1LjM1NzE0MjkiIHJ5PSIyNSI+PC9lbGxpcHNlPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgRedBubbleNew as ReactComponent };